// extracted by mini-css-extract-plugin
module.exports = {"reset":"ResetPasswordToken_reset__WduKX","title":"ResetPasswordToken_title__3IuEB","fadeIn":"ResetPasswordToken_fadeIn__3qsxR","fadeOut":"ResetPasswordToken_fadeOut__2lRx7"};